import { Core } from '../../Constants';
import { rdfs, Schema } from '../../Vocabs';
function getTitle(res) {
    return res[Core.Vocab('title')] || res[rdfs('label')] || res[Schema('title')];
}
function getDescription(res) {
    return res[Core.Vocab('description')] || res[rdfs('comment')] || res[Schema('description')];
}
export function Mixin(Base) {
    return class HydraResource extends Base {
        get description() {
            return getDescription(this);
        }
        get title() {
            return getTitle(this);
        }
    };
}
export function shouldApply(res) {
    const hasDescription = !!(getDescription(res));
    const hasTitle = !!(getTitle(res));
    return hasDescription || hasTitle;
}
//# sourceMappingURL=DocumentedResource.js.map